export default __webpack_public_path__ + "static/heroDesktop-6d58f6952438838b588d705b70529a34.png";